module.exports = __webpack_public_path__ + "img/avatar-girl.2f0a6202.png";